<template>
    <div class="company-profile">
      <div class="profile-title">公司简介</div>
      <div class="profile-description">与创造者同行，与客户共成长</div>
      <div class="profile-content">
        <div class="paragraph">
          <span class="red-font">璞华科技，专业的PLM研发管理解决方案提供商。</span>璞华易研PLM产品汇聚10余年研发管理经验而成，是产品研发过程中最为重要的创新管理平台和协同办公平台。璞华易研PLM已在化工材料、医疗器械、芯片半导体、电子科技、新能源、食品医药等行业得到了广泛应用，为企业提供一整套完整的智能化产品生命周期管理解决方案，有效缩短产品研发周期，改善产品设计迭代流程，降低企业研发成本。
        </div>
        <div class="paragraph">
          与此同时，在快速变化的市场环境中，璞华易研PLM基于行业用户反馈，不断进行产品迭代升级，满足不同行业用户的研发管理需求，让更多的企业享受到行业最佳实践。
        </div>
        <div class="content-img">
          <img v-lazy="om1" alt="">
        </div>
        <div class="paragraph">
          公司现有员工1000余人，在全球拥有<span class="blue-font">苏州、武汉、北京、香港、东京</span>等研发中心。公司坚持走自主创新之路，先后与北京大学、华中科技大学、武汉大学等高校开展项目联合研发，每年投入大量资金、人员进行技术研发，拥有数百项软件著作权及发明专利。同时，公司与<span class="blue-font">Microsoft、Oracle、IBM、HP、EMC、Pivotal、Yahoo、HITACHI、Accenture、PWC、VMware、华为、CIC</span>等世界顶级企业建立了战略合作关系，客户遍及中、日、东南亚、北美、欧洲等多个国家和地区。
        </div>
      </div>
      
    </div>
</template>

<script>
import om1 from '@/assets/images/om1.png'
export default {
  data() {
    return {
      om1
    }
  },
  watch: {
  
  },
  mounted() {
  },
  destroyed() {
  },
  methods: {
   
  }
}
</script>

<style lang="scss" scoped>
$img: "../../assets/images";

.company-profile {
  padding: 0 26rem 12rem;
  background-color: #f0f2f5;
  .profile-title {
    padding: 9rem 0 2.4rem;
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 4rem;
    color: #333333;
    line-height: 4rem;
    text-align: center;
    font-style: normal;
    text-transform: uppercase;
  }
  .profile-description {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 1.8rem;
    color: #666A77;
    line-height: 1.8rem;
    text-align: center;
    font-style: normal;
  }
  .profile-content {
    .paragraph {
      width: 140rem;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 2.2rem;
      color: #333333;
      line-height: 3.6rem;
      text-align: left;
      font-style: normal;
      margin-top: 4.2rem;
      .red-font {
        color: #FB0000;
      }
      .blue-font {
        color: #1485F6;
      }
    }
    .content-img {
      padding: 5rem 5.4rem 0;
      height: 66rem;
      img {
        width: 100%;
        height: 61rem;
      }

    }
  }
}

@import "@/styles/mixins.scss";

@include mobile {
  .company-profile {
    padding: 0 1.6rem 4.8rem;
    .profile-title {
      font-size: 2.4rem;
      line-height: 3.2rem;
      padding: 4.8rem 0 1.6rem;
    }
    .profile-description {
      font-size: 1.4rem;
      line-height: 2.2rem;
    }
    .profile-content {
      .paragraph {
        width: 100%;
        font-size: 1.5rem;
        line-height: 2.6rem;
      }
      .content-img {
        padding: 2.4rem 0 0;
        height: auto;
        img {
          width: 100%;
          height: auto;
          object-fit: contain;
        }
      }
    }
  }
}
</style>
